import { HttpService } from './../http-with-injector/http.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable()
export class OnlineAuthService {

  private isLoggedIn$ = new BehaviorSubject<string>('initial');
  public isOnlineLoggedIn$ = this.isLoggedIn$.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    public http: HttpService
  ) { }


  private signin_subject = new BehaviorSubject<any>({ open: null, edit: null });
  signin = this.signin_subject.asObservable();

  signInCall(data) {
    this.signin_subject.next(data);
  }


  onlineStoreLogin(data: any) {
    return this.http.post('customers/login', data).toPromise();
  }

  onlineStoreRegister(data: any) {
    return this.http.post('customers/register', data).toPromise();
  }

  forgetPassword(data) {
    return this.http.post('customers/forgot-password', data).toPromise();
  }

  resetPassword(data, key) {
    return this.http.post('customers/reset-password/' + key, data).toPromise();
  }

  checkLogin(): Observable<boolean | any> {
    return new Observable((observer) => {
        setInterval(() => {
            observer.next(this.authenticated);
        }, 1000);
    });
  }

  setUser(user, remember: boolean) {
      user['expiry_time'] = new Date().getTime() + 604800000;
      const current_user =  JSON.stringify(user);
      if (isPlatformBrowser(this.platform)){
        if (remember) {
            localStorage.setItem('onlineAuthUser', current_user);
        } else {
            sessionStorage.setItem('onlineAuthUser', current_user);
        }
        localStorage.removeItem('currentUser');
      } else{
        this.document.onlineAuthUser = current_user;
      }
      this.isLoggedIn$.next('loggedin');
  }

  getUser() {
    if(isPlatformBrowser(this.platform)){
      return JSON.parse(localStorage.getItem('onlineAuthUser') || sessionStorage.getItem('onlineAuthUser'));
  
    }
  }

  removeUser(key) {
    if(isPlatformBrowser(this.platform)){
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
    this.isLoggedIn$.next('loggedout');
    this.router.navigate(['/']);
  }

  removeUserFormAdmin(key) {
    if(isPlatformBrowser(this.platform)){
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
  }

  get userData() {
      return this.getUser();
  }

  get authenticated(): boolean {
      const user = this.getUser();
      let nowTime = new Date().getTime();
      if (user && user['expiry_time'] && (user['expiry_time'] > nowTime)) return true;
      return false;
  }
}
